import { render, staticRenderFns } from "./SwitchTenancyAgreement.vue?vue&type=template&id=e039dcca&scoped=true&"
import script from "./SwitchTenancyAgreement.vue?vue&type=script&lang=js&"
export * from "./SwitchTenancyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTenancyAgreement.vue?vue&type=style&index=0&id=e039dcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e039dcca",
  null
  
)

export default component.exports